export default __webpack_public_path__ + "static/media/05_photo.01ad2784.jpg";